import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import Sales from "./pages/Sales";
import Why from "./pages/Why";
import WhyRechecklist from "./pages/WhyRechecklist";
import Benefits from "./pages/Benefits";
import Testimonials from "./pages/Testimonials";
import Pricing from "./pages/Pricing";
import PurchaseAgreement from "./pages/PurchaseAgreement";
import BrokerPilot from "./pages/BrokerPilot";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import Pay from "./pages/Pay";
import Login from "./pages/Login";
import Support from "./pages/Support";
import SupportRole from "./pages/SupportRole";
import Vendors from "./pages/Vendors";
import VendorDirectory from "./pages/VendorDirectory";
import VendorDetail from "./pages/VendorDetail";
import GuidedTour from "./pages/GuidedTour";
import SalesDemo from "./pages/SalesDemo";
import FilmChaos from "./pages/FilmChaos";
import FilmHuman from "./pages/FilmHuman";
import SalesTourHost from "@tour/SalesTourHost.jsx";
import Board from "./pages/Board";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import CalendarPage from "./pages/CalendarPage";
import ManualsIndex from "./pages/manuals/ManualsIndex";
import ManualRoutes from "./pages/manuals/ManualRoutes";
import ProHub from "./pages/ProHub";
import ClientHub from "./pages/ClientHub";
import BetaIntro from "./pages/beta/BetaIntro";
import BetaAgreement from "./pages/beta/BetaAgreement";
import BetaProfile from "./pages/beta/BetaProfile";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Layout>
        <SalesTourHost />
        <Routes>
          <Route path="/" element={<Sales />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/why" element={<Why />} />
          <Route path="/why-rechecklist" element={<WhyRechecklist />} />
          <Route path="/benefits/:role" element={<Benefits />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/purchase-agreement" element={<PurchaseAgreement />} />
          <Route path="/broker-pilot" element={<BrokerPilot />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pay" element={<Pay />} />
          <Route path="/login" element={<Login />} />
          <Route path="/guide" element={<Navigate to="/manuals" replace />} />
          <Route path="/guide/:slug" element={<Navigate to="/manuals" replace />} />
          <Route path="/manuals" element={<ManualsIndex />} />
          <Route path="/manuals/:role" element={<ManualRoutes page="home" />} />
          <Route path="/manuals/:role/:slug" element={<ManualRoutes page="topic" />} />
          <Route path="/support" element={<Support />} />
          <Route path="/support/tour" element={<GuidedTour />} />
          <Route path="/demo" element={<SalesDemo />} />
          <Route path="/demo/chaos" element={<FilmChaos />} />
          <Route path="/demo/human" element={<FilmHuman />} />
          <Route path="/support/vendors" element={<Navigate to="/vendors" replace />} />
          <Route path="/support/:role" element={<SupportRole />} />
          <Route path="/vendors" element={<Vendors />} />
          <Route path="/vendors/pro" element={<VendorDirectory audience="pro" />} />
          <Route path="/vendors/client" element={<VendorDirectory audience="client" />} />
          <Route path="/vendors/:id" element={<VendorDetail />} />
          <Route path="/board" element={<Board />} />
          <Route path="/community" element={<Board />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/pro" element={<ProHub />} />
          <Route path="/clients" element={<ClientHub />} />
          <Route path="/beta" element={<BetaIntro />} />
          <Route path="/beta/agreement" element={<BetaAgreement />} />
          <Route path="/beta/profile" element={<BetaProfile />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
